"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LANGUAGE_SELECTED_STORAGE_KEY = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

var _utils = _interopRequireDefault(require("@insided/shared/modules/MultiLanguage/utils"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LANGUAGE_SELECTED_STORAGE_KEY = 'languageSelected';
exports.LANGUAGE_SELECTED_STORAGE_KEY = LANGUAGE_SELECTED_STORAGE_KEY;

function getSelectedLanguageFromStorage() {
  return sessionStorage.getItem(LANGUAGE_SELECTED_STORAGE_KEY);
}

var LanguageSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LanguageSelector, _Component);

  var _super = _createSuper(LanguageSelector);

  function LanguageSelector() {
    var _getSelectedLanguageF, _this$props$community;

    var _this;

    (0, _classCallCheck2.default)(this, LanguageSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedLanguage: getSelectedLanguageFromStorage() && !_this.props.resetSelectedLanguage ? JSON.parse((_getSelectedLanguageF = getSelectedLanguageFromStorage()) !== null && _getSelectedLanguageF !== void 0 ? _getSelectedLanguageF : '') : {
        id: (_this$props$community = _this.props.communityLanguage) === null || _this$props$community === void 0 ? void 0 : _this$props$community.id,
        title: _this.props.communityLanguage ? _this.props.communityLanguage.name : '',
        value: _this.props.communityLanguage ? _this.props.communityLanguage.locale : ''
      }
    });
    return _this;
  }

  (0, _createClass2.default)(LanguageSelector, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props, enabledLanguages, publishedLanguages;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, enabledLanguages = _this$props.enabledLanguages, publishedLanguages = _this$props.publishedLanguages;
                _context.next = 3;
                return this.updateLanguageTitles(enabledLanguages !== null && enabledLanguages !== void 0 ? enabledLanguages : [], publishedLanguages !== null && publishedLanguages !== void 0 ? publishedLanguages : []);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(prevProps) {
        var _this$props2, resetSelectedLanguage, communityLanguage, enabledLanguages, publishedLanguages, enabledLanguagesUpdated, publishedLanguagesUpdated;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, resetSelectedLanguage = _this$props2.resetSelectedLanguage, communityLanguage = _this$props2.communityLanguage, enabledLanguages = _this$props2.enabledLanguages, publishedLanguages = _this$props2.publishedLanguages;

                if (resetSelectedLanguage && communityLanguage) {
                  this.onLanguageSelected(communityLanguage === null || communityLanguage === void 0 ? void 0 : communityLanguage.id);
                }

                enabledLanguagesUpdated = JSON.stringify(enabledLanguages) !== JSON.stringify(prevProps.enabledLanguages);
                publishedLanguagesUpdated = JSON.stringify(publishedLanguages) !== JSON.stringify(prevProps.publishedLanguages);

                if (!(enabledLanguagesUpdated || publishedLanguagesUpdated)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return this.updateLanguageTitles(enabledLanguages !== null && enabledLanguages !== void 0 ? enabledLanguages : [], publishedLanguages !== null && publishedLanguages !== void 0 ? publishedLanguages : []);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "updateLanguageTitles",
    value: function () {
      var _updateLanguageTitles = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(enabledLanguages, publishedLanguages) {
        var _selectedLanguage$val, _selectedLanguage$val2;

        var selectedLanguage, languages, languageTitles;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                selectedLanguage = this.state.selectedLanguage;
                languages = [].concat((0, _toConsumableArray2.default)(enabledLanguages), (0, _toConsumableArray2.default)(publishedLanguages));
                _context3.next = 4;
                return (0, _utils.default)(languages);

              case 4:
                languageTitles = _context3.sent;
                this.setState({
                  languageTitles: languageTitles,
                  selectedLanguage: _objectSpread(_objectSpread({}, selectedLanguage), {}, {
                    title: languageTitles[(_selectedLanguage$val = selectedLanguage.value) !== null && _selectedLanguage$val !== void 0 ? _selectedLanguage$val : ''] ? languageTitles[(_selectedLanguage$val2 = selectedLanguage.value) !== null && _selectedLanguage$val2 !== void 0 ? _selectedLanguage$val2 : ''] : ''
                  })
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateLanguageTitles(_x2, _x3) {
        return _updateLanguageTitles.apply(this, arguments);
      }

      return updateLanguageTitles;
    }()
  }, {
    key: "mapLanguagesToNestedDropdownItem",
    value: function mapLanguagesToNestedDropdownItem(languages) {
      var languageTitles = this.state.languageTitles;
      return languages.map(function (language) {
        var _languageTitles$langu;

        return {
          id: language.id,
          title: (_languageTitles$langu = languageTitles === null || languageTitles === void 0 ? void 0 : languageTitles[language.locale]) !== null && _languageTitles$langu !== void 0 ? _languageTitles$langu : language.name,
          children: []
        };
      });
    }
  }, {
    key: "findLanguageById",
    value: function findLanguageById(languageId) {
      var _this$props3 = this.props,
          enabledLanguages = _this$props3.enabledLanguages,
          publishedLanguages = _this$props3.publishedLanguages;
      var foundEnabledLanguage = enabledLanguages === null || enabledLanguages === void 0 ? void 0 : enabledLanguages.find(function (language) {
        return language.id === languageId;
      });
      if (foundEnabledLanguage) return foundEnabledLanguage;
      var foundPublishedLanguage = publishedLanguages === null || publishedLanguages === void 0 ? void 0 : publishedLanguages.find(function (language) {
        return language.id === languageId;
      });
      if (foundPublishedLanguage) return foundPublishedLanguage;
      return undefined;
    }
  }, {
    key: "onLanguageSelected",
    value: function onLanguageSelected(languageId) {
      if (languageId === null) return;
      var languageTitles = this.state.languageTitles;
      var language = this.findLanguageById(String(languageId));

      if (language) {
        var _languageTitles$langu2, _this$props$onLanguag, _this$props4;

        var selectedLanguage = {
          id: language.id,
          title: (_languageTitles$langu2 = languageTitles === null || languageTitles === void 0 ? void 0 : languageTitles[language.locale]) !== null && _languageTitles$langu2 !== void 0 ? _languageTitles$langu2 : language.name,
          value: language.locale
        };
        this.setState({
          selectedLanguage: selectedLanguage
        });
        window.sessionStorage.setItem(LANGUAGE_SELECTED_STORAGE_KEY, JSON.stringify(selectedLanguage));
        (_this$props$onLanguag = (_this$props4 = this.props).onLanguageSelected) === null || _this$props$onLanguag === void 0 ? void 0 : _this$props$onLanguag.call(_this$props4, language.code);
      }
    }
  }, {
    key: "getUnpublishedLanguageOptions",
    value: function getUnpublishedLanguageOptions(enabledLanguages) {
      var _this2 = this;

      var enabledLanguagesDropdownItems = this.mapLanguagesToNestedDropdownItem(enabledLanguages);
      return (0, _preact.h)("div", {
        key: "Unpublished Languages"
      }, (0, _preact.h)(_NestedDropdownHeader.default, null, "Unpublished Languages"), (0, _preact.h)(_NestedDropdown.default, {
        items: enabledLanguagesDropdownItems,
        onSelectItem: function onSelectItem(languageId) {
          return _this2.onLanguageSelected(languageId);
        },
        depth: 1
      }));
    }
  }, {
    key: "getPublishedLanguageOptions",
    value: function getPublishedLanguageOptions(publishedLanguages) {
      var _this3 = this;

      var publishedLanguagesDropdownItems = this.mapLanguagesToNestedDropdownItem(publishedLanguages);
      return (0, _preact.h)("div", {
        key: "Published Languages"
      }, (0, _preact.h)(_NestedDropdownHeader.default, null, "Published Languages"), (0, _preact.h)(_NestedDropdown.default, {
        items: publishedLanguagesDropdownItems,
        onSelectItem: function onSelectItem(languageId) {
          return _this3.onLanguageSelected(languageId);
        },
        depth: 1
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _enabledLanguages$fil,
          _this4 = this,
          _publishedLanguages$f;

      var selectedLanguage = this.state.selectedLanguage;
      var _this$props5 = this.props,
          enabledLanguages = _this$props5.enabledLanguages,
          publishedLanguages = _this$props5.publishedLanguages,
          fill = _this$props5.fill,
          width = _this$props5.width;
      var filteredEnabledLanguages = (_enabledLanguages$fil = enabledLanguages === null || enabledLanguages === void 0 ? void 0 : enabledLanguages.filter(function (language) {
        return language.id !== _this4.state.selectedLanguage.id;
      })) !== null && _enabledLanguages$fil !== void 0 ? _enabledLanguages$fil : [];
      var filteredPublishedLanguages = (_publishedLanguages$f = publishedLanguages === null || publishedLanguages === void 0 ? void 0 : publishedLanguages.filter(function (language) {
        return language.id !== _this4.state.selectedLanguage.id;
      })) !== null && _publishedLanguages$f !== void 0 ? _publishedLanguages$f : [];
      var hasEnabledLanguages = filteredEnabledLanguages.length > 0;
      var hasPublishedLanguages = filteredPublishedLanguages.length > 0;
      if (!hasEnabledLanguages && !hasPublishedLanguages) return null;
      var unpublishedLanguageOptions = hasEnabledLanguages ? this.getUnpublishedLanguageOptions(filteredEnabledLanguages) : null;
      var publishedLanguageOptions = hasPublishedLanguages ? this.getPublishedLanguageOptions(filteredPublishedLanguages) : null;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('language-selector-container', 'dropdown-container', {
          fill: fill,
          fixedWidth: width
        }),
        style: width ? "--language-selector-width: ".concat(width) : ''
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: true,
        popupName: "language-selector-dropdown",
        className: "dropdown-selector",
        trigger: (0, _preact.h)(_Button.default, {
          title: selectedLanguage.title,
          endIcon: "chevronDown",
          size: "medium",
          fullWidth: true,
          "data-qa": "select-category"
        }),
        triggerClass: "dropdown-selector-wrapper--control"
      }, publishedLanguageOptions, unpublishedLanguageOptions));
    }
  }]);
  return LanguageSelector;
}(_preact.Component);

var _default = LanguageSelector;
exports.default = _default;